import { getContext } from '@fiverr-private/fiverr_context';
import { WEB, MOBILE_WEB } from './constants';

export const getPlatform = () => getContext().isTouch ? MOBILE_WEB : WEB;
